export class SalesforceFileListModel {
	id: string;
	title: string;
	description: string;
	extension: string;
	type: string;
	size: number;
}
